/**
 * BDOEX API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * Contact: mateusz.surma@mae.pl
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApproveAndGeneratePlannedCardRequest } from '../model/approveAndGeneratePlannedCardRequest';
import { BdoServiceModelsEnumerationsCompanyType } from '../model/bdoServiceModelsEnumerationsCompanyType';
import { WasteRegisterPublicApiApiModelsResponsesWasteRegisterWasteTransferCardV1PlannedKpoDto } from '../model/wasteRegisterPublicApiApiModelsResponsesWasteRegisterWasteTransferCardV1PlannedKpoDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PlannedWasteCardService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param kpoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public approvePlanned(kpoId: string, observe?: 'body', reportProgress?: boolean): Observable<WasteRegisterPublicApiApiModelsResponsesWasteRegisterWasteTransferCardV1PlannedKpoDto>;
    public approvePlanned(kpoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WasteRegisterPublicApiApiModelsResponsesWasteRegisterWasteTransferCardV1PlannedKpoDto>>;
    public approvePlanned(kpoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WasteRegisterPublicApiApiModelsResponsesWasteRegisterWasteTransferCardV1PlannedKpoDto>>;
    public approvePlanned(kpoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (kpoId === null || kpoId === undefined) {
            throw new Error('Required parameter kpoId was null or undefined when calling approvePlanned.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WasteRegisterPublicApiApiModelsResponsesWasteRegisterWasteTransferCardV1PlannedKpoDto>('patch',`${this.basePath}/api/V2/PlannedWasteCard/Carrier/PlannedCard/${encodeURIComponent(String(kpoId))}/Approve`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param kpoId 
     * @param body 
     * @param role 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public approvePlannedAndGenerateConfirmation(kpoId: string, body?: ApproveAndGeneratePlannedCardRequest, role?: BdoServiceModelsEnumerationsCompanyType, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public approvePlannedAndGenerateConfirmation(kpoId: string, body?: ApproveAndGeneratePlannedCardRequest, role?: BdoServiceModelsEnumerationsCompanyType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public approvePlannedAndGenerateConfirmation(kpoId: string, body?: ApproveAndGeneratePlannedCardRequest, role?: BdoServiceModelsEnumerationsCompanyType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public approvePlannedAndGenerateConfirmation(kpoId: string, body?: ApproveAndGeneratePlannedCardRequest, role?: BdoServiceModelsEnumerationsCompanyType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (kpoId === null || kpoId === undefined) {
            throw new Error('Required parameter kpoId was null or undefined when calling approvePlannedAndGenerateConfirmation.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (role !== undefined && role !== null) {
            queryParameters = queryParameters.set('role', <any>role);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('patch',`${this.basePath}/api/V2/PlannedWasteCard/${encodeURIComponent(String(kpoId))}/ApproveAndGenerateConfirmation`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
